import * as React from "react";
import { SVGProps } from "react";
const SvgAirportShuttle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    {...props}
  >
    <path d="M155-235q-35-35-35-85H40v-360q0-33 23.5-56.5T120-760h560l240 240v200h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85H360q0 50-35 85t-85 35q-50 0-85-35Zm445-325h160L640-680h-40v120Zm-240 0h160v-120H360v120Zm-240 0h160v-120H120v120Zm155.5 275.5Q290-299 290-320t-14.5-35.5Q261-370 240-370t-35.5 14.5Q190-341 190-320t14.5 35.5Q219-270 240-270t35.5-14.5Zm480 0Q770-299 770-320t-14.5-35.5Q741-370 720-370t-35.5 14.5Q670-341 670-320t14.5 35.5Q699-270 720-270t35.5-14.5ZM120-400h32q17-18 39-29t49-11q27 0 49 11t39 29h304q17-18 39-29t49-11q27 0 49 11t39 29h32v-80H120v80Zm720-80H120h720Z" />
  </svg>
);
export default SvgAirportShuttle;
